import { render, staticRenderFns } from "./BroadcastForm.vue?vue&type=template&id=72b76368"
import script from "./BroadcastForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports